import { FechaFunctionsService } from '@/utils/functions.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '@services/general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-movimiento',
  templateUrl: './modal-movimiento.component.html',
  styleUrls: ['./modal-movimiento.component.scss']
})
export class ModalMovimientoComponent {
  @Input() cssClass: string;
  @Input() label: string;
  @Input() icon: string;
  @Input() idMovimiento: number;
  ultimoCierre: number;
  movimientoForm: FormGroup;
  FecMov = this.Func.Today(true);
  @Input() labelMonto: string = "Monto"
  @Output() updateData = new EventEmitter();

  constructor(private modalService: NgbModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService,
    public Func: FechaFunctionsService) {
    this.initializeForm();
  }

  ngOnInit() {
    let intervalId = setInterval(() => {
      this.movimientoForm.get('fechaMovimiento')?.setValue(this.Func.DateTimeSecondFormated(this.Func.Today(true)), { emitEvent: false }); // Actualiza el FormControl
    }, 1000); // Actualiza cada segundo
    this.getUltimoCierre();
  }

  initializeForm() {
    this.movimientoForm = this.fb.group({
      fechaMovimiento: [, Validators.required],
      montoMovimiento: [, Validators.required],
      motivoMovimiento: [],
    });
  }

  onlyNumber(e: any) {
    const regExp = /[^0-9]+/g;
    e.target.value = e.target.value.replace(regExp, '');
  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      //Cerrado/guardado retornando objeto
      this.updateData.emit({
        "id_tipomovimiento": this.idMovimiento,
        "fecha_movimiento": this.movimientoForm.get("fechaMovimiento").value.split(" ")[0],
        "hora_movimiento": this.movimientoForm.get("fechaMovimiento").value.split(" ")[1],
        "ingreso_movimiento": this.idMovimiento == 1 || this.idMovimiento == 3 ? this.movimientoForm.get("montoMovimiento").value : 0,
        "egreso_movimiento": this.idMovimiento == 2 || this.idMovimiento == 4 ? this.movimientoForm.get("montoMovimiento").value : 0,
        "motivo_movimiento": this.movimientoForm.get("motivoMovimiento").value
      });
      this.initializeForm();
    }, (reason) => {
      //Cerrasdo por X, ESC, backdrop
    });
  }

  getUltimoCierre() {
    if (this.idMovimiento == 1) {
      this.generalService.getListar("arqueo/ultimocierre")
        .then(res => {
          let ultimoCierre = res.data[0].monto_cierre;
          if (ultimoCierre != 0) {
            this.movimientoForm.get('montoMovimiento')?.setValue(ultimoCierre)
            this.movimientoForm.get('montoMovimiento')?.disable()
          }
          else {
            this.movimientoForm.get('montoMovimiento')?.setValue("")
            this.movimientoForm.get('montoMovimiento')?.enable()
          }
        })
        .catch(err => {
          this.movimientoForm.get('montoMovimiento')?.setValue("")
          this.movimientoForm.get('montoMovimiento')?.enable()
        })
    }
  }
}
